export default {"src":"/_next/static/media/stethoscope.749c253a.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};